import {useEffect, useState} from "react";
import {Col, Input, Modal, Row} from "antd";
import i18next from "i18next";
import * as Setting from "../../conf/Setting";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import moment from "moment";

export const DepartmentEdit = ({dept, mode, visible, setVisible, onSubmitDepartment, onEditDepartment}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [department, setDepartment] = useState(dept);

  useEffect(() => {
    setDepartment(dept);
  }, [dept]);

  const submitDepartment = () => {
    if (department.displayName.trim() === "") {
      Setting.showMessage("error", i18next.t("department:Display name can not be empty"));
      return;
    }

    const deptObj = Setting.deepCopy(department);
    if (deptObj.displayName.length > 50) {
      Setting.showMessage("error", i18next.t("department:Display name is limited in 50 characters"));
      return;
    }

    if (department.code.trim() === "") {
      Setting.showMessage("error", i18next.t("部门Code不能为空"));
      return;
    }

    if (deptObj.code.length > 30) {
      Setting.showMessage("error", i18next.t("department:Code is limited in 30 characters"));
      return;
    }

    deptObj.updatedTime = moment().format("yyyy-MM-DD HH:mm:ss");
    setConfirmLoading(true);
    if (mode === "edit") {
      OrganizationBackend.updateDepartment(deptObj.uid, deptObj)
        .then(res => {
          setConfirmLoading(false);
          if (res.status === "ok") {
            setVisible(false);
            Setting.showMessage("success", i18next.t("general:Successfully saved"));
            onSubmitDepartment(mode);
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          setConfirmLoading(false);
          setVisible(false);
          Setting.showResponseMessage(error);
        });
    } else {
      deptObj.createdTime = moment().format("yyyy-MM-DD HH:mm:ss");
      OrganizationBackend.addDepartment(deptObj)
        .then(res => {
          setConfirmLoading(false);
          if (res.status === "ok") {
            setVisible(false);
            Setting.showMessage("success", i18next.t("general:Successfully saved"));
            onSubmitDepartment(mode);
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          setConfirmLoading(false);
          setVisible(false);
          Setting.showResponseMessage(error);
        });
    }
  };

  return (
    <Row>
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title={mode === "edit" ? i18next.t("department:Edit Department") : i18next.t("department:Add New Department")}
        visible={visible}
        okText={i18next.t("general:Confirm")}
        cancelText={i18next.t("general:Cancel")}
        confirmLoading={confirmLoading}
        onCancel={() => {setVisible(false);}}
        onOk={submitDepartment}
        width={620}
      >
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px", marginRight: "4px"}} span={(Setting.isMobile()) ? 4 : 4}>
            {Setting.getLabel(i18next.t("department:Display name"), i18next.t("department:Display name - Tooltip"), true)} :
          </Col>
          <Col span={19} >
            <Input value={department?.displayName}
              placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)}
              onChange={e => {
                setDepartment({...department, ...{displayName: e.target.value}});
              }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px", marginBottom: "48px"}} >
          <Col style={{marginTop: "5px", marginRight: "4px"}} span={(Setting.isMobile()) ? 4 : 4}>
            {Setting.getLabel(i18next.t("department:Code"), i18next.t("department:Code - Tooltip"), true)} :
          </Col>
          <Col span={19} >
            <Input value={department?.code}
              placeholder={i18next.t("general:Limited number of characters is {number}").replace("{number}", 30)}
              onChange={e => {
                setDepartment({...department, ...{code: e.target.value}});
              }} />
          </Col>
        </Row>
      </Modal>
    </Row>
  );
};

export default DepartmentEdit;
